import React, { useEffect } from 'react';

import { IFilterValueSelectorProps } from './interfaces';
import { Checkbox } from '@mui/material';
import _ from 'lodash';

export default function BooleanSelector({ filterValues, setFilterValues }: IFilterValueSelectorProps) {
  useEffect(() => setFilterValues([null]), []);

  return (
    <Checkbox
      size="small"
      sx={{ p: 0 }}
      checked={_.first(filterValues) === 'true'}
      onChange={(event) => setFilterValues([event.target.checked ? 'true' : 'false'])}
      onClick={(e) => e.stopPropagation()}
    />
  );
}
